$('body').on('click', '*[data-analytics-event-name]', (e) => {
  // Wherever possible, analytics events should originate in page controllers.
  // Client-side events can be used for interactions which are client-side only (eg mailto links, expanding/collapsing)
  const eventName = $(e.target).attr('data-analytics-event-name');

  var postData = {};
  postData.event_name = eventName;

  $.each(e.target.attributes, function() {
    if(this.specified && this.name.indexOf('data-analytics-event-param-') === 0) {
      var paramName = this.name.replace('data-analytics-event-param-','');
      postData[paramName] = this.value;
    }
  });

  $.ajax(
    `${ETL_PS_CONFIG.analyticsMeasurementUrl}`,
    {
      method: 'POST',
      data: postData
    }
  )
    .then(
      function success() {
        // Do nothing, the event was collected
      },
      function fail() {
        // Do nothing, the request failed but there's nothing we can do
      }
    );
})
